import { darken } from "polished"

const globalNotice = {
  color: ({ theme }) => theme.colors.white,
  backgroundColor: {
    info: ({ theme }) => darken(0.2, theme.colors.lightGreen),
    warning: ({ theme }) => darken(0.2, theme.colors.yellow),
    critical: ({ theme }) => theme.colors.red,
  },
}

export default globalNotice
